<template>
    <button type="button" class="pdf-thumbnail" :class="{ 'pdf-thumbnail-active': active }"
        :aria-label="`Go to page ${number}`" :aria-current="active ? 'page' : null" @click="$emit('select', number)">
        <span class="pdf-thumbnail-image" :style="{ aspectRatio: aspectRatio }">
            <canvas ref="canvas" aria-hidden="true"></canvas>
            <span v-if="error" class="text-xs text-gray-500">Preview unavailable</span>
        </span>
        <span class="text-xs">{{ number }}</span>
    </button>
</template>
<script>
export default {
    props: ['pdf', 'runtime', 'number', 'active', 'scroller'],
    data() { return { aspectRatio: 612 / 792, error: false }; },
    mounted() {
        this.generation = 0;
        this.observer = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) this.render();
            else this.release();
        }, { root: this.scroller, rootMargin: '200px 0px' });
        this.observer.observe(this.$el);
    },
    beforeDestroy() { this.observer.disconnect(); this.release(); },
    methods: {
        release() {
            this.generation++;
            if (this.task) this.task.cancel();
            this.task = null;
            this.$refs.canvas.width = this.$refs.canvas.height = 0;
        },
        async render() {
            const previous = this.task;
            this.release();
            const generation = this.generation;
            try {
                if (previous) await previous.promise.catch(() => {});
                const page = await this.pdf.getPage(this.number);
                if (generation !== this.generation) return;
                const normal = page.getViewport({ scale: 1 });
                this.aspectRatio = normal.width / normal.height;
                const viewport = page.getViewport({ scale: 128 / normal.width });
                const canvas = this.$refs.canvas;
                canvas.width = Math.ceil(viewport.width * 2);
                canvas.height = Math.ceil(viewport.height * 2);
                this.task = page.render({ canvasContext: canvas.getContext('2d'), viewport,
                    transform: [2, 0, 0, 2, 0, 0], annotationMode: this.runtime.AnnotationMode.ENABLE });
                await this.task.promise;
            } catch (error) {
                if (generation === this.generation && error.name !== 'RenderingCancelledException') this.error = true;
            }
        },
    },
};
</script>
<style>
.pdf-thumbnail { display: flex; flex-direction: column; align-items: center; gap: 6px; width: 100%; padding: 8px; border: 2px solid transparent; border-radius: 6px; color: #4b5563; }
.pdf-thumbnail:hover { background: #e5e7eb; }
.pdf-thumbnail-active { border-color: #2563eb; background: #eff6ff; color: #1d4ed8; }
.pdf-thumbnail-image { display: block; width: 100%; background: white; box-shadow: 0 1px 4px #0003; overflow: hidden; }
.pdf-thumbnail-image canvas { display: block; width: 100%; height: 100%; }
</style>
